<script>
  import {
    projectDetail,
    projectSaleDetails,
    tokenPurchased,
  } from "../../../../store";
  import ProgressBar from "../../../../components/progressbar/ProgressBar.svelte";
  import {
    signer,
    signerAddress,
    provider,
    defaultEvmStores,
  } from "svelte-ethers-store";
  import { metaMaskExtensionInstallationLink } from "../../../../constants/constants";
  import Button from "../../../../components/button/Button.svelte";
  import { getContext, onMount, onDestroy } from "svelte";
  import { BigNumber, ethers } from "ethers";
  import BuyModal from "../../../../components/buy-modal/BuyModal.svelte";
  import ApprovalModal from "../../../../components/approval-modal/ApprovalModal.svelte";
  import SaleStartModal from "../../../../components/sale-start-modal/SaleStartModal.svelte";
  import { formateToPrecision, getTime } from "../../../../utils";

  $: if ($projectSaleDetails.deployBlock) {
    minimumStatus = $projectSaleDetails.token.minimumTier;
    tierData = $projectSaleDetails.token.tier;
  }

  let saleTokenPrice,
    approved = false,
    checkApprovalPromise,
    eligibleStatus = 0;
  let tierData, minimumStatus, latestBlock;

  $: $provider &&
    signerAddress &&
    (async () => {
      latestBlock = await $provider.getBlockNumber();
    })();

  $: latestBlock && (eligibleStatus = 0);

  $: if (saleCardDetails?.price) {
    saleTokenPrice = saleCardDetails.price;
  } else {
    saleTokenPrice = $projectDetail.project_token_price;
  }
  export let saleCardDetails, sale, token, saleData, reserve, projectTierData;

  const { open } = getContext("simple-modal");

  const setApprovalValue = (approval) => {
    approved = approval;
  };

  const checkApproval = async () => {
    if ($signerAddress && reserve && !approved) {
      const allowance = await reserve.erc20Contract.allowance(
        $signerAddress,
        sale.address
      );
      approved = allowance.gte(
        BigNumber.from(ethers.constants.MaxUint256).div(BigNumber.from(2))
      );
    }
  };

  const canStart = async () => {
    try {
      return await sale.canStart();
    } catch (error) {}
  };

  const canEnd = async () => {
    try {
      return await sale.canEnd();
    } catch (error) {}
  };

  let timer;

  const updateSaleStatus = () => {
    if (saleCardDetails.saleStatus == 1 && !timer) {
      timer = setInterval(() => {
        const { timeRemaining } = getTime(saleData.data.sales[0]);
        saleCardDetails = { ...saleCardDetails, endTime: timeRemaining };
        if (timeRemaining == "Raise Ended") {
          return clearTimeout(timer);
        }
      }, 1000);
    } else if (saleCardDetails.saleStatus > 1) {
      saleCardDetails = { ...saleCardDetails, endTime: "Raise Ended" };
    }
  };

  const checkSaleStatus = async () => {
    let status = await sale.saleStatus();
    if (status != saleCardDetails.saleStatus) {
      saleCardDetails = { ...saleCardDetails, saleStatus: status };
      updateSaleStatus();
    }
  };

  $: if (saleCardDetails && !timer) {
    updateSaleStatus();
  }

  $: $signerAddress, reserve && checkApproval();

  onMount(() => {
    checkApprovalPromise = checkApproval();
  });

  onDestroy(() => {
    if (timer) clearTimeout(timer);
  });

  $: totalAvailableTokens =
    formateToPrecision(saleCardDetails.totalSupply - $tokenPurchased);
</script>

<div class="right ml-auto">
  <div class="top-section-raise">
    <section>
      Total raised in Previous Tiers
      <strong>${$projectDetail.tiers ?? ""}</strong>
    </section>
  </div>
  <div class="token-counter flex">
    <span class="flex column-direction">
      <em>POOL SIZE</em>
      <b
        >${isNaN(saleTokenPrice * totalAvailableTokens)
          ? ""
          : formateToPrecision(saleTokenPrice * totalAvailableTokens)}</b
      >
    </span>
    <span class="flex column-direction ml-auto">
      <em class="text-right">PROJECT TOKEN</em>
      <b class="text-right">
        {saleCardDetails.tokenName ?? ""}
        <strong
          >{saleCardDetails.tokenSymbol
            ? `(${saleCardDetails.tokenSymbol})`
            : ""}</strong
        >
      </b>
    </span>
  </div>
  <div class="flex list-section">
    <div class="boxes boxes-width flex column-direction">
      <div class="box h-100 flex flex-text-center column-direction">
        <span>Price Per Token</span>

        <strong>${formateToPrecision(saleTokenPrice) ?? ""}</strong>
      </div>
    </div>
    <div class="boxes boxes-width flex column-direction ml-auto">
      <div class="box">
        <span>Total Available Tokens:</span>
        <strong
          >{isNaN(totalAvailableTokens) ? "0" : totalAvailableTokens}</strong
        >
      </div>
    </div>
  </div>
  <div class="boxes flex column-direction w-100 list-section">
    <div class="box">
      <span>Individual purchase limit</span>
      <strong>
        {isNaN(saleCardDetails.walletCap - $tokenPurchased)
          ? ""
          : formateToPrecision(saleCardDetails.walletCap - $tokenPurchased)}
        {saleCardDetails.tokenSymbol ?? ""}
      </strong>
    </div>
  </div>
  <div class="flex launch-date list-section">
    <div class="boxes flex column-direction">
      <div class="box">
        <span>Launch Date</span>
        <strong class="time">{saleCardDetails.startTime ?? ""}</strong>
      </div>
    </div>
    <div class="boxes flex column-direction ml-auto">
      <div class="box">
        <span class="text-right">Ending Date</span>
        <strong class="time">
          {saleCardDetails.endTime ? saleCardDetails.endTime : ""}
        </strong>
      </div>
    </div>
  </div>
  <div class="progress-title">
    {#if $projectSaleDetails.address}
      <div class="flex items-center launch-date">
        <ProgressBar {saleCardDetails} {saleTokenPrice} />
      </div>
    {/if}
  </div>
  {#if !$signerAddress}
    <Button
      id="preview-connect-btn"
      buttonClass={"participate-btn "}
      on:click={() => {
        defaultEvmStores.setProvider().catch(() => {
          setTimeout(
            () => window.open(metaMaskExtensionInstallationLink, "_blank"),
            1000
          );
        });
      }}
    >
      Connect Wallet
    </Button>
  {/if}
  {#if saleCardDetails.saleStatus === 0}
    {#if $projectDetail.project_status !== "Completed" && $signerAddress && sale}
      {#await canStart()}
        <Button
          id="preview-sale-start"
          buttonClass={"participate-btn disabled "}
        >
          Start Sale
          <img src="./images/btn-load.gif" alt="load" />
        </Button>
      {:then value}
        <Button
          id="preview-sale-start-disabled"
          buttonClass={`participate-btn ${value ? "" : "disabled "}`}
          on:click={() => {
            open(
              SaleStartModal,
              { sale, isStartSale: true },
              {},
              { onClosed: checkSaleStatus }
            );
          }}
        >
          Start Sale
        </Button>
      {/await}
    {/if}
  {:else if saleCardDetails.saleStatus === 1 && $signerAddress}
    {#if saleCardDetails.endTime == "Raise Ended" && sale}
      {#await canEnd()}
        <Button id="preview-sale-end" buttonClass={"participate-btn disabled "}>
          End Sale
          <img src="./images/btn-load.gif" alt="load" />
        </Button>
      {:then value}
        <Button
          id="preview-sale-end-disabled"
          buttonClass={`participate-btn ${value ? "" : "disabled "}`}
          on:click={() => {
            open(
              SaleStartModal,
              { sale, isStartSale: false },
              {},
              { onClosed: checkSaleStatus }
            );
          }}
        >
          End Sale
        </Button>
      {/await}
    {:else if checkApprovalPromise && eligibleStatus >= minimumStatus}
      {#await checkApprovalPromise}
        <Button
          id="preview-approved-disabled"
          buttonClass={"participate-btn disabled "}
        >
          Approve
          <img src="./images/btn-load.gif" alt="load" />
        </Button>
      {:then}
        {#if !approved && $signerAddress && reserve}
          <Button
            id="preview-approved"
            buttonClass={"participate-btn "}
            on:click={() => {
              open(
                ApprovalModal,
                { signer, reserve, sale, saleData, setApprovalValue },
                {},
                {
                  onClosed: () => {
                    checkApprovalPromise = checkApproval();
                  },
                }
              );
            }}
          >
            Approve
          </Button>
        {:else if $signerAddress && reserve}
          <Button
            id="preview-buy-btn"
            buttonClass={"participate-btn "}
            on:click={() => {
              open(BuyModal, { signer, sale, token, reserve, saleData,saleCardDetails });
            }}
          >
            Buy
          </Button>
        {/if}
      {/await}
    {/if}
  {/if}
</div>
